import React, { useEffect } from 'react';
import { Field, change } from 'redux-form';
import { useSelector, useDispatch } from 'react-redux';
import { FieldForm } from '@app/src/common/FieldForm';
import { maxLength } from '@app/src/utils/normalize';
import * as validate from '@app/src/utils/validations';
import { renderInput } from '@app/src/common/Input';

interface Props {
  modelVehicle: number;
  isDisabled?: boolean;
}

export const InputYearVehicle: React.FC<Props> = ({ modelVehicle, isDisabled }) => {
  const dispatch = useDispatch();
  const print = useSelector(state => state.print.general);
  const printYear = useSelector(state => state.print.general.yearVehicle);
  const currentYear = useSelector(state => state.form.stepOne.values.yearVehicle);

  useEffect(() => {
    if (print.modelVehicle && print.modelVehicle !== modelVehicle) {
      dispatch(change('stepOne', 'yearVehicle', ''));
    }
  }, [modelVehicle]);

  useEffect(() => {
    if (printYear) {
      dispatch(change('stepOne', 'yearVehicle', print.yearVehicle));
    }
  }, [printYear]);

  return (
    <FieldForm label="Año">
      <Field
        name="yearVehicle"
        type="number"
        placeholder="Ingrese año"
        component={renderInput}
        normalize={maxLength(4)}
        validate={[validate.required, validate.minLength4, validate.isBetween1920And2022]}
        defaultValue={currentYear}
        disabled={isDisabled}
      />
    </FieldForm>
  )
};
